/**
 * Dependencies
 */
import http from '../../../services/HttpService'

/**
 * Get the user's collateral
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const getCollateral = ({ commit }) => {
    commit('SET_LOADING')
    http
        .get('servicing/collaterals/')
        .then(res => commit('GET_COLLATERAL_SUCCESS', res.data))
        .then(() => commit('RESET_LOADING'))
        .then(() => commit('GET_COLLATERAL_FAILURE'))
}

/**
 * Generate a new collateral object
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
const createCollateral = ({ commit, dispatch }, payload) => {
    http
        .post('servicing/collaterals/', payload)
        .then(() => dispatch('getCollateral'))
        .then(() => dispatch('toggleFormModal'))
        .then(() => dispatch('addNotification', {
            title: 'Collateral created',
            type: 'success',
            text: 'The collateral was successfully created',
            timeout: true
        }, { root: true }))
        .catch(err => commit('SAVE_COLLATERAL_FAILURE', err.response.data))
}

const destroyCollateral = ({ commit, dispatch }, id) => {
    http
        .del(`servicing/collaterals/${id}/`)
        .then(() => commit('REMOVE_COLLATERAL_SUCCESS', id))
        .then(() => dispatch('addNotification', {
            title: 'Collateral deleted',
            type: 'success',
            text: 'The collateral was successfully deleted',
            timeout: true
        }, { root: true }))
}

/**
 * Toggle the visibility of the collateral creation modal
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Promise}
 */
const toggleFormModal = ({ commit, state }) => commit('TOGGLE_CREATE_MODAL')

/**
 * Toggle the visibility of the upload file modal
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Promise}
 */
const toggleUploadModal = ({ commit, state }, id) => commit('TOGGLE_UPLOAD_MODAL', id)

/**
 * Clear validation errors for a given key
 *
 * @param  {Function} options.commit
 * @param  {String} key
 * @return {Promise}
 */
const clearErrors = ({ commit }, key) => commit('CLEAR_ERRORS', key)

/**
 * Reset the form params
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const resetCollateralForm = ({ commit }) => commit('RESET_FORM')

/**
 * Set up the edit context
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
const editForm = ({ commit }, id) => commit('SET_EDITABLE_COLLATERAL', id)

/**
 * Update an existing collateral
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {Object} form
 * @return {Void}
 */
const updateColateral = ({ commit, dispatch, state }, form) => {
    http.patch(`servicing/collaterals/${state.editing.id}/`, form)
        .then(() => dispatch('getCollateral'))
        .then(() => dispatch('toggleFormModal'))
        .then(() => dispatch('addNotification', {
            title: 'Collateral Updated',
            type: 'success',
            text: 'The collateral was successfully updated',
            timeout: true
        }, { root: true }))
        .catch(err => commit('SAVE_COLLATERAL_FAILURE', err.response.data))
}

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const resetState = ({ commit }) => commit('RESET_STATE')

export default {
    editForm,
    resetState,
    clearErrors,
    getCollateral,
    toggleFormModal,
    updateColateral,
    createCollateral,
    toggleUploadModal,
    destroyCollateral,
    resetCollateralForm
}



// WEBPACK FOOTER //
// ./src/state/modules/debt-servicing/actions.js